"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../types");
var _utils = require("../../utils");
var _SocketEvents = require("../../constants/SocketEvents");
var _Sources = require("@studio/constants/Sources");
var _cancelDisconnectSource = _interopRequireDefault(require("./cancelDisconnectSource"));
var _StudioLogger = require("@studio/logger/StudioLogger");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var LOG = new _StudioLogger.StudioLogger('createOrUpdateSource');

/**
 * Creates or updates a source based on whether a source with the same title already exists.
 * If a source with the same title exists, it updates that source. Otherwise, it creates a new source.
 * After creating or updating, it emits a socket event to notify of the source toggle.
 *
 * @param {Object} payload - The source payload data
 * @param {string} payload.sourceId - The ID of the source to update (if updating)
 * @param {boolean} payload.cameraUnavailable - Whether the camera is available
 * @param {string} payload.description - The description of the source
 * @param {number} payload.order - The order of the source
 * @param {string} payload.role - The role of the source
 * @param {string} payload.title - The title of the source
 * @param {string} payload.value - The value of the source
 * @param {string} payload.type - The type of the source
 * @param {string} payload.userId - The userId for the source being created
 * @returns {Function} Redux thunk action
 */
function createOrUpdateSource(payload) {
  return (0, _utils.withCurrentParams)(function (dispatch, _ref, getState, socket) {
    var _existingSource;
    var teamId = _ref.teamId,
      eventId = _ref.eventId,
      broadcastId = _ref.broadcastId;
    var _getState = getState(),
      sources = _getState.broadcastSources.sources;
    var existingSource = sources.find(function (_ref2) {
      var value = _ref2.value,
        user = _ref2.user,
        _id = _ref2._id,
        title = _ref2.title,
        type = _ref2.type;
      // If sourceId is provided, match by _id
      if (payload.sourceId) {
        return _id === payload.sourceId;
      }

      // For cameraPresenter type, match by userId to ensure only one source per user
      // or match by title if userId is not provided (for unassigned/placeholder sources)
      if (payload.type === _Sources.CAMERA_PRESENTER && type === _Sources.CAMERA_PRESENTER) {
        return user === payload.userId || !user && title === payload.title;
      }
      return value === payload.value;
    });

    // For screen presenter, if no active source found, check for disconnected or unassigned source with matching title
    if (!existingSource && payload.type === _Sources.SCREEN_PRESENTER) {
      var _payload$title;
      var payloadTitle = (_payload$title = payload.title) === null || _payload$title === void 0 ? void 0 : _payload$title.toLowerCase().replaceAll(/\s+/g, '');
      existingSource = sources.find(function (source) {
        var _source$title;
        return source.type === _Sources.SCREEN_PRESENTER && source.disconnected && source.value !== payload.value && source.value !== _Sources.UNASSIGNED && ((_source$title = source.title) === null || _source$title === void 0 ? void 0 : _source$title.toLowerCase().replaceAll(/\s+/g, '')) === payloadTitle;
      });
      if (!existingSource) {
        existingSource = sources.find(function (source) {
          var _source$title2;
          return source.type === _Sources.SCREEN_PRESENTER && source.value === _Sources.UNASSIGNED && (payload.userId ? source.createdBy === payload.userId && source.title === payload.title : ((_source$title2 = source.title) === null || _source$title2 === void 0 ? void 0 : _source$title2.toLowerCase().replaceAll(/\s+/g, '')) === payloadTitle);
        });
      }
    }
    if ((_existingSource = existingSource) !== null && _existingSource !== void 0 && _existingSource.disconnected) {
      dispatch((0, _cancelDisconnectSource["default"])(existingSource._id));
    }
    var attendeeId = payload.value;
    var type = existingSource ? _types.BROADCAST_UPDATE_SOURCE : _types.BROADCAST_CREATE_SOURCE;
    var action = {
      type: type,
      request: function () {
        var _request = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(apiClient) {
          var response, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                LOG.info("".concat(existingSource ? 'Updating' : 'Creating', " source"), {
                  payload: payload
                });
                if (!existingSource) {
                  _context.n = 7;
                  break;
                }
                _context.p = 1;
                _context.n = 2;
                return apiClient.broadcast.updateSource(teamId, eventId, broadcastId, existingSource._id, (0, _utils.buildSourcePayload)(payload));
              case 2:
                response = _context.v;
                _context.n = 6;
                break;
              case 3:
                _context.p = 3;
                _t = _context.v;
                if (!(_t.response && _t.response.status === 404)) {
                  _context.n = 5;
                  break;
                }
                LOG.warn('Failed to update source (may have been deleted), falling back to create:', _t);
                action.type = _types.BROADCAST_CREATE_SOURCE;
                _context.n = 4;
                return apiClient.broadcast.createSource(teamId, eventId, broadcastId, (0, _utils.buildSourcePayload)(payload));
              case 4:
                response = _context.v;
                _context.n = 6;
                break;
              case 5:
                throw _t;
              case 6:
                _context.n = 9;
                break;
              case 7:
                _context.n = 8;
                return apiClient.broadcast.createSource(teamId, eventId, broadcastId, (0, _utils.buildSourcePayload)(payload));
              case 8:
                response = _context.v;
              case 9:
                LOG.info("".concat(action.type === _types.BROADCAST_UPDATE_SOURCE ? 'Updated' : 'Created', " source"), {
                  response: response
                });
                socket.emit(_SocketEvents.SOURCE_TOGGLE, {
                  broadcastId: broadcastId,
                  notifyingDirector: attendeeId,
                  source: response
                });
                return _context.a(2, response);
            }
          }, _callee, null, [[1, 3]]);
        }));
        function request(_x) {
          return _request.apply(this, arguments);
        }
        return request;
      }()
    };
    dispatch(action);
  });
}
var _default = exports["default"] = createOrUpdateSource;